<template>
  <OArticleCard
    v-bind="$attrs"
    class="embed-card-wrapper flex items-center bg-white border border-divider-[#E2E5ED] rounded-md h-[90px] sm:h-[130px]"
  >
    <template #desktop>
      <OArticleCover height="130" width="231" class="flex-shrink-0 rounded-l-md" />
      <OArticleBadge pin="left" />
      <div class="h-full p-4 hover:text-link-primary">
        <OArticleTitle class="text-lg font-semibold leading-24 line-clamp-2" />
        <div class="inline-flex bg-[#E2E5ED] mt-4 px-4 flex items-center h-[34px] rounded-md">
          <div class="font-semibold text-sm mr-4">{{ $t('news-page.show-article') }}</div>
          <OIcon icon="arrow-right" svg-class="w-[15.75px] h-[18px]" />
        </div>
      </div>
    </template>
    <template #mobile>
      <OArticleCover height="90" width="160" class="flex-shrink-0 rounded-l-md" />
      <OArticleBadge pin="left" />
      <div class="px-3 hover:text-link-primary">
        <OArticleTitle class="text-13 font-semibold leading-18 line-clamp-4" />
      </div>
    </template>
  </OArticleCard>
</template>

<script>
import OArticleBadge from '@/modules/card/components/ArticleBadge';
import OArticleCard from '~/modules/card/components/ArticleCard';
import OArticleCover from '~/modules/card/components/ArticleCover';
import OArticleTitle from '~/modules/card/components/ArticleTitle';
import { OIcon } from '~/modules/common/components/ui';

export default {
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleBadge,
    OIcon,
  },
  inheritAttrs: false,
};
</script>
